import axios from "axios";
import { useEffect, useState } from "react";
import video from "../../assets/video/sejarah.mp4";

export default function Content() {
    const [currentNumberTeller, setCurrentNumberTeller] = useState('');
    const [currentNumberCs, setCurrentNumberCs] = useState('');

    const getData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_REACT}/v1/testing`);
            console.log("Queue data:", response.data);
            setCurrentNumberTeller(response.data.data.current_number_teller);
            setCurrentNumberCs(response.data.data.current_number_cs);
        } catch (error) {
            console.error("Error fetching queue data:", error);
        }
    };

    useEffect(() => {
        getData(); 

        const interval = setInterval(() => {
            getData(); 
        }, 2000);

        return () => clearInterval(interval); 
    }, []);

    return (
        <div className="flex flex-col md:flex-row justify-center items-center">
            <div>
                <div className="w-full p-4">
                    <div className="border-2 border-gray-200 p-4">
                        <div className="text-center font-bold">
                            <h1 className="text-4xl font-bold text-blue-800 mb-4">BPR PALU ANUGERAH</h1>
                            <div className="border-4 border-blue-500 rounded-lg p-8 mb-6 mt-10">
                                <p className="text-2xl mb-2">NOMOR ANTRIAN TELLER</p>
                                <p className="text-8xl font-bold text-blue-600">{currentNumberTeller}</p>
                            </div>
                            <div className="text-xl">
                                <p className="mb-2">Silakan Menunggu</p>
                                <p>Terima kasih atas kesabaran Anda</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full p-4">
                    <div className="border-2 border-gray-200 p-4">
                        <div className="text-center font-bold">
                            <h1 className="text-4xl font-bold text-blue-800 mb-4">BPR PALU ANUGERAH</h1>
                            <div className="border-4 border-blue-500 rounded-lg p-8 mb-6 mt-10">
                                <p className="text-2xl mb-2">NOMOR ANTRIAN CS</p>
                                <p className="text-8xl font-bold text-blue-600">{currentNumberCs}</p>
                            </div>
                            <div className="text-xl">
                                <p className="mb-2">Silakan Menunggu</p>
                                <p>Terima kasih atas kesabaran Anda</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="w-full md:w-1/2 p-4">
                <div className="border-2 border-gray-200 p-4 flex justify-center items-center">
                    <video className="w-full h-[818px]" controls muted autoPlay loop>
                        <source src={video} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </div>
    );
}
